import * as api from '../../redux/api/actions.js'

import EulaDialog, {
  COOKIES_BACKEND_IDENTIFIER,
  COOKIES_NAME,
  PRIVACY_BACKEND_IDENTIFIER,
  PRIVACY_NAME,
  USERS_LICENSE_BACKEND_IDENTIFIER,
  USERS_LICENSE_NAME,
} from './eula/EulaDialog'
import { Link, Navigate } from 'react-router-dom'
import { withRouter } from '../../utils/withRouterCompat'
import React, { Component } from 'react'
import {
  acceptTerm,
  dismissEula,
  login,
  logout,
} from '../../redux/auth/actions.js'

import Alert from '@mui/material/Alert'
import Loading from '../../components/Loading'
import Box from '@mui/material/Box'
import { Button } from '@mui/material'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import ZoetisLogo from '../../assets/img/logo_corte.png'
import { connect } from 'react-redux'

const termsMapping = {
  [COOKIES_BACKEND_IDENTIFIER]: COOKIES_NAME,
  [PRIVACY_BACKEND_IDENTIFIER]: PRIVACY_NAME,
  [USERS_LICENSE_BACKEND_IDENTIFIER]: USERS_LICENSE_NAME,
}

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      login: '',
      password: '',
      tipo: 1,
      helperText: '',
      error: false,
      cookiesVersion: null,
      privacyVersion: null,
      usersLicenseVersion: null,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.onAcceptTerms = this.onAcceptTerms.bind(this)
  }

  componentDidMount() {
    this.props.logout()
  }

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event

    this.setState(() => ({ [name]: value }))
  }

  handleBlur = (e) => {
    let usuarioEmailCPF = e.target.value
    let regexpNumber = new RegExp('^[0-9]{11}$')
    let regexEmail = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$')
    if (regexpNumber.test(usuarioEmailCPF)) {
      let valor = this.cpfMask(e.target.value)
      this.setState({ login: valor, helperText: '', error: false, tipo: 0 })
    } else if (regexEmail.test(usuarioEmailCPF)) {
      this.setState({
        login: usuarioEmailCPF,
        helperText: '',
        error: false,
        tipo: 1,
      })
    } else {
      this.setState({
        login: usuarioEmailCPF,
        helperText: 'E-mail invalido!',
        error: true,
        tipo: 1,
      })
    }
  }

  handleSubmit() {
    //Setando os valores para usuario => email || cpf
    let valor = this.state.login

    localStorage.setItem(
      'L - ' + new Date(),
      JSON.stringify({ email: this.state.login }),
    )
    // valor = valor.replace('.', '').replace('.', '').replace('-', '');
    this.setState({ login: valor })

    this.props.login(this.state)
  }

  onEnterPress = (e) => {
    if (e.keyCode == 13 && e.shiftKey == false && e.target.value != '') {
      e.preventDefault()
      this.handleSubmit()
    }
  }

  async onAcceptTerms() {
    this.props.dismissEula()
    const token = this.props.token
    let success = true
    for (const BACKEND_IDENTIFIER of [
      COOKIES_BACKEND_IDENTIFIER,
      PRIVACY_BACKEND_IDENTIFIER,
      USERS_LICENSE_BACKEND_IDENTIFIER,
    ]) {
      const termAccepted = await this.props.acceptTerm({
        type: BACKEND_IDENTIFIER,
        token,
      })
      if (termAccepted) {
        this.setState({ [termsMapping[BACKEND_IDENTIFIER]]: termAccepted })
      } else {
        success = false
      }
    }
    if (success) {
      this.handleSubmit()
    }
  }

  canSubmit() {
    return this.state.login && this.state.password
  }

  cpfMask = (value) => {
    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  }

  render() {
    if (this.props.loggedIn) return <Navigate to='/' replace />
    if (this.props.showLoading) {
      return <Loading open />
    }
    return (
      <>
        <CssBaseline />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            px: 2,
            py: 4,
          }}
        >
          <Container maxWidth='xs' disableGutters>
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 1,
                p: { xs: 3, sm: 4 },
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <img
                  src={ZoetisLogo}
                  alt='Zoetis Gerar'
                  style={{ width: 200, maxWidth: '100%' }}
                />
              </Box>

              {this.props.error && (
                <Alert severity='error' sx={{ mb: 2 }}>
                  {this.props.error.title}
                </Alert>
              )}

              <TextField
                id='login'
                label='E-mail'
                name='login'
                variant='outlined'
                type='text'
                error={this.state.error}
                helperText={this.state.helperText}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                value={this.state.login.toLowerCase().replace(/ /g, '')}
                style={{ width: '100%', marginTop: 16 }}
              />

              <TextField
                id='login-form-password'
                label='Senha'
                name='password'
                variant='outlined'
                type='password'
                onChange={this.handleChange}
                onKeyDown={this.onEnterPress}
                style={{ width: '100%', marginTop: 16 }}
              />

              <Button
                variant='contained'
                color='primary'
                size='large'
                style={{ width: '100%', marginTop: 16 }}
                disabled={!this.canSubmit() || this.state.error}
                onClick={this.handleSubmit}
              >
                Entrar
              </Button>
            </Box>
          </Container>
        </Box>
        <Container disableGutters>
          <EulaDialog
            visible={this.props.shouldAcceptEULA}
            onAccept={this.onAcceptTerms}
          />
        </Container>
      </>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (params) => dispatch(login(params)),
    logout: (params) => dispatch(logout()),
    acceptTerm: ({ type, token }) => dispatch(acceptTerm({ type, token })),
    dismissEula: () => dispatch(dismissEula()),
  }
}

const mapStateToProps = (state) => ({
  error: api.getApiError(state, `Authentication/Login`) || false,
  success: api.getApiResult(state, `Authentication/Login`) || false,
  loading: api.getApiLoading(state, `Authentication/Login`),
  showLoading: state.screen.loading,
  loggedIn: state.auth.loggedIn,
  shouldAcceptEULA: state.auth.shouldAcceptEULA,
  token: state.auth.token,
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login))
